import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import lang from '@blade-sxp/monitor-center/lang/index';
import VideoStream from '@blade-sxp/monitor-center/pages/components/video-stream.vue';
import screenfull from 'screenfull';
import ControlModule from '@blade-sxp/monitor-center/store/index';
let default_1 = class default_1 extends Vue {
    selectedDeviced;
    selectedDevicedArr;
    dragDevicedId;
    dragDevicedName;
    dragDevicedType;
    isDragStyle;
    singleScreenIndex; // 选中的屏幕: number;
    fourScreen = false; // 单屏和四屏
    fullscreen = false; // 全屏
    cameraWidth = 0; // 视频初始宽度
    cameraHeight = 0; // 视频初始高度
    // 监听退出全屏
    checkFull() {
        // console.log('parent', parent);
        let fullScreen = parent.document.webkitIsFullScreen ||
            parent.document.fullscreen ||
            parent.document.mozFullScreen ||
            parent.document.msFullscreenElement;
        if (fullScreen === undefined) {
            fullScreen = false;
        }
        return fullScreen;
    }
    mounted() {
        window.addEventListener('resize', () => {
            if (!this.checkFull())
                this.fullscreen = false;
        });
        this.fourScreen = ControlModule.fourScreen; // 单屏和四屏
        this.fullscreen = ControlModule.fullscreen;
    }
    beforeDestroy() {
        ControlModule.updateFourScreen(this.fourScreen);
        ControlModule.updateFullscreen(this.fullscreen);
    }
    changeMode(isFourScreen) {
        this.$emit('update:singleScreenIndex', 0);
        this.fourScreen = isFourScreen;
    }
    videoStreamEnlarge() {
        this.enlarge();
    }
    enlarge() {
        // if (this.selectedDeviced?.filter((item) => item).length === 0) return;
        this.fullscreen = !this.fullscreen;
        const element = document.getElementById('container_max'); // 指定全屏区域元素
        if (screenfull.isEnabled) {
            screenfull.request(element);
        }
        screenfull.toggle();
    }
    changeIsDragStyle(bool) {
        this.$emit('update:isDragStyle', bool);
    }
    changesingleScreenIndex(bool) {
        this.$emit('update:singleScreenIndex', bool);
    }
};
__decorate([
    Prop()
], default_1.prototype, "selectedDeviced", void 0);
__decorate([
    Prop()
], default_1.prototype, "selectedDevicedArr", void 0);
__decorate([
    Prop()
], default_1.prototype, "dragDevicedId", void 0);
__decorate([
    Prop()
], default_1.prototype, "dragDevicedName", void 0);
__decorate([
    Prop()
], default_1.prototype, "dragDevicedType", void 0);
__decorate([
    Prop()
], default_1.prototype, "isDragStyle", void 0);
__decorate([
    Prop()
], default_1.prototype, "singleScreenIndex", void 0);
default_1 = __decorate([
    Component({
        name: 'rightPreview',
        components: { VideoStream },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
